// extracted by mini-css-extract-plugin
export default {"inputs":"IncomeSourceFrom_inputs__Er421"};